<template>
	<section class="library-container">
		<div class="cutblock"></div>
		<div class="container sm-padding-none">
			<div class="books-feed">
				<div class="category-heading">
					<h3>Книги</h3>
					<hr>
					<div class="wp-content">
					<div class="welcome-to-history-book">
						Дорогой друг! Приветствуем тебя на туристическом сайте Георгиевского городского округа и приглашаем совершить виртуальное путешествие в историческое прошлое бывшей крепости Азово-Моздокской оборонительной линии.
					</div>
					<hr>
				</div>
				</div>
				<div v-if="loaded">
					<div v-for="category in books" :key="category.category">
						<h5 v-html="category.category" class="sub-category-heading"></h5>
						<div class="row">
							<div class="col-sm-12 col-md-6 col-lg-6 col-xl-3" v-for="book in category.books" :key="book.id">
								<router-link :to="'/library/books/'+book.id" class="book">
									<div class="book-name" v-html="book.acf.title"></div>
									<div class="book-image" :style="{'background-image': 'url(' + book.acf.cover.sizes.medium + ')'}"></div>
									<div class="book-cover" :style="{'background-color': book.acf.cover_color}"></div>
									<div class="book-page-1"></div>
									<div class="bookmark"></div>
									<div class="book-page-2"></div>
									<div class="book-page-3"></div>
									<div class="book-back-cover" :style="{'background-color': book.acf.cover_color}"></div>
								</router-link>
							</div> 
						</div>
					</div>
				</div>
				<div class="row" v-else>
					<div class="col-sm-12 col-md-6 col-lg-6 col-xl-4" v-for="cap in [1,2,3,4,5,6]" :key="cap">
						<a class="the-place">
							<div class="place-photo"></div>
							<div class="description">
								<div class="content-placeholder">
									<div class="container-loading h-line-3">
										<div class="line width-60"></div>
									</div>
									<div class="container-loading p-lines-16">
										<div class="line"></div>
										<div class="line width-40"></div>
									</div>
								</div>
							</div>
						</a>
					</div>
				</div>
				<div class="category-heading">
				<br>
				<br>
				<br>
					<h3>Фотоальбомы</h3>
					<hr>
					<div class="row">
						<div class="col-sm-12 col-md-6 col-lg-6 col-xl-3" v-for="album in albums" :key="album.id">
								<router-link :to="'/library/albums/'+album.id" class="book">
									<div class="book-name" v-html="album.acf.title"></div>
									<div class="book-image" :style="{'background-image': 'url(' + album.acf.cover.sizes.medium + ')'}"></div>
									<div class="book-cover" :style="{'background-color': album.acf.cover_color}"></div>
									<div class="book-page-1"></div>
									<div class="bookmark"></div>
									<div class="book-page-2"></div>
									<div class="book-page-3"></div>
									<div class="book-back-cover" :style="{'background-color': album.acf.cover_color}"></div>
								</router-link>
							</div> 
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import store from "../../store/";
import _ from "lodash";

export default {
	name: "LibraryFeed",
	store,
	created() {
		this.$store.dispatch("LibraryFeed/fetchAllBooks");
	},
	computed: {
		loaded() {
			return this.$store.state["LibraryFeed"].loaded;
		},
		books() {
			return this.$store.state["LibraryFeed"].books;
		},
		albums() {
			return this.$store.state["LibraryFeed"].albums;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/LibraryFeed/index.vue